import React from 'react';
import { Button } from "antd";
import { Dialog, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import Logout from '../../Helper/Logout/Logout';
import { ThemeProperties } from '../../Theme/ThemeProperties';



function SessionExpired({isSessionExpired}) {
    return (
        <Dialog
        aria-labelledby="customized-dialog-title"
        open={isSessionExpired}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: "50%",
            height: 150,
          },
        }}
      >
        <div
          style={{
            padding: "16px",
            display: "inline",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          <InfoIcon sx={{fontSize:"20px",color:ThemeProperties.purple}}/>
          <br/>
          <br/>
          <Typography variant="paperHeader">
            Your session is expired! Please login again
          </Typography>
          <div
            className="dropDownBottom"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              type="primary"
              onClick={() => Logout(false)}
              style={{ backgroundColor: ThemeProperties.purple }}
            >
              Login
            </Button>
          </div>
        </div>
      </Dialog>
    );
}

export default SessionExpired;